/* eslint-disable @typescript-eslint/no-unused-expressions */
import AddIcon from "@mui/icons-material/Add";
import useUser from "../../services/queries/useUser";
import useUkm from "../../services/queries/useUkm";
import Spinner from "../Spinner/Spinner";
import SearchIcon from "@mui/icons-material/Search";
import CardBarang from "../CardBarang/CardBarang";
import useKategori from "../../services/queries/useKategori";
import React, { useEffect, useState, useRef } from "react";
import { useAuthStore } from "../../stores/authStore";
import {
    ModalStokField,
    ParamsGetItem,
    ParamsGetKategori,
} from "../../constants/types";
import { ReactComponent as BarangTidakDitemukan } from "../../assets/images/BarangTidakDitemukan.svg";
import {
    TextField,
    Button,
    Box,
    Typography,
    Stack,
    useMediaQuery,
    IconButton,
    InputAdornment,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTransaksiStore } from "../../stores/transaksiStore";
import useInfiniteItem from "../../services/queries/useInfiniteItem";
import { getLocalUkmId } from "../../utils/handleChangeUkmId";
import { LoadingButton } from "@mui/lab";
import MenuBarang from "../MenuBarang/MenuBarang";
import ViewListIcon from "@mui/icons-material/ViewList";
import GridViewIcon from "@mui/icons-material/GridView";
import useUkmIsDueExpired from "../../services/queries/useUkmIsDueExpired";
import CardBarangMini from "../CardBarang/CardBarangMini";
import ModalStok from "../ModalStok/ModalStok";
import ModalDetailBarang from "../ModalDetailBarang/ModalDetailBarang";
import useUrlState from "../../hooks/useUrlState";

const listBarangSchema = {
    search: {
        defaultValue: "",
        parse: (raw: string) => raw,
        serialize: (v: string) => v,
    },
    kategori: {
        defaultValue: "",
        parse: (raw: string) => raw,
        serialize: (v: string) => v,
    },
};

interface IListBarangProps {
    isCardView: boolean;
    cardView: () => void;
    listView: () => void;
    handleIsError: () => void;
    onOpenMutasi: () => void;
}

const ListBarang = ({
    isCardView,
    cardView,
    listView,
    handleIsError,
    onOpenMutasi,
}: IListBarangProps) => {
    const [urlState, setUrlState] = useUrlState(listBarangSchema);
    const { data: user, status: loadingUser } = useUser();
    const ukmIdUser = useAuthStore((s) => s.ukmIdUser);
    const theme = useTheme();

    const isFetchingItems = useTransaksiStore((s) => s.isFetchingItems);
    const cancelFetchingItems = useTransaksiStore((s) => s.cancelFetchingItems);
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const initialParamsUkm = React.useMemo(
        () => ({
            size: 500,
            page: 1,
            search: "",
        }),
        [],
    );
    const { data: ukm } = useUkm(initialParamsUkm);

    const initialParamsItem = {
        ukmId: undefined,
        size: 50,
        page: 1,
        isShow: 1,
        search: urlState.search,
        kategori: urlState.kategori,
    };

    const initialParamsKategori = {
        ukmId: undefined,
        size: 500,
        page: 1,
        search: "",
        kategori: "",
    };

    const [search, setSearch] = useState<string>(() => urlState.search);
    const [dataStok, setDataStok] = useState<ModalStokField>();
    const [isOpenModalStok, setIsOpenModalStok] = useState(false);
    const [detailModalState, setDetailModalState] = useState<{
        open: boolean;
        namaBarang: string;
        url?: string;
        deskripsi?: string;
    }>({
        open: false,
        namaBarang: "",
        url: "",
        deskripsi: "",
    });

    const openModalStok = (data?: ModalStokField) => {
        if (data) {
            setDataStok((prev) => ({
                ...prev,
                ...data,
            }));
        }
        setIsOpenModalStok(true);
    };
    const closeModalStok = () => {
        setIsOpenModalStok(false);
        setDataStok(undefined);
    };

    const handleOpenDetailBarang = React.useCallback(
        (namaBarang: string, url: string, deskripsi?: string) => {
            setDetailModalState({
                open: true,
                namaBarang,
                url,
                deskripsi,
            });
        },
        [],
    );

    const handleCloseDetailBarang = React.useCallback(() => {
        setDetailModalState((prev) => ({
            ...prev,
            open: false,
        }));
    }, []);
    
    const [paramsItem, setParamsItem] =
        useState<ParamsGetItem>(initialParamsItem);
    const [paramsKategori, setParamsKategori] = useState<ParamsGetKategori>(
        initialParamsKategori,
    );

    const {
        data: item,
        status: loadingItem,
        refetch,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isError: isErrorItem,
    } = useInfiniteItem(paramsItem);
    const {
        data: datakategori,
        status: loadingKategori,
        refetch: refetchKategori,
        isError: isErrorKategori,
    } = useKategori(paramsKategori);

    const initialParamsUkmIsDueExpired = React.useMemo(
        () => ({
            search: "",
            size: 50,
            page: 1,
            isDueExpired: 1,
        }),
        [],
    );
    const { data: ukmIsDueExpired } = useUkmIsDueExpired(
        initialParamsUkmIsDueExpired,
    );
    const [kategori, setKategori] = useState(() => urlState.kategori);
    const isSearchMountRef = useRef(true);

    const ukmId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalUkmId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const ukmData = React.useMemo(() => {
        if (ukmId) {
            return ukm?.content.find((li) => li.id === ukmId);
        }
        return ukm?.content[0];
    }, [ukm?.content, ukmId]);

    const handleClickOpen = React.useCallback(() => {
        openModalStok();
    }, []);

    const handleChangeSearch = React.useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            setSearch(event.target.value);
        },
        [],
    );

    const handleSearch = React.useCallback(() => {
        setParamsItem((prev) => {
            if (prev.search === search && prev.page === 1) {
                return prev;
            }
            return {
                ...prev,
                search: search,
                page: 1,
            };
        });
        setUrlState({ search });
    }, [search, setUrlState]);

    const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (isSearchMountRef.current) {
            isSearchMountRef.current = false;
            return;
        }

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        searchTimeoutRef.current = setTimeout(() => {
            setParamsItem((prev) => {
                if (prev.search === search && prev.page === 1) {
                    return prev;
                }
                return {
                    ...prev,
                    search: search,
                    page: 1,
                };
            });
            setUrlState({ search });
        }, 1000);

        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, [search, setUrlState]);

    useEffect(() => {
        setParamsItem((prev) => {
            if (prev.kategori === (kategori || "") && prev.page === 1) {
                return prev;
            }
            return {
                ...prev,
                kategori: kategori || "",
                page: 1,
            };
        });
        setUrlState({ kategori: kategori || "" });
    }, [kategori, setUrlState]);

    const selectedUkmId = ukmIdUser?.[0];

    useEffect(() => {
        if (selectedUkmId === undefined || selectedUkmId === null) {
            return;
        }
        setParamsItem((prev) => {
            if (prev.ukmId === selectedUkmId && prev.page === 1) {
                return prev;
            }
            return {
                ...prev,
                ukmId: selectedUkmId,
                page: 1,
            };
        });
        setParamsKategori((prev) => {
            if (prev.ukmId === selectedUkmId) {
                return prev;
            }
            return {
                ...prev,
                ukmId: selectedUkmId,
            };
        });
    }, [selectedUkmId]);

    useEffect(() => {
        if (isFetchingItems === true) {
            refetch();
            refetchKategori();
            cancelFetchingItems();
        }
    }, [cancelFetchingItems, isFetchingItems, refetch, refetchKategori]);

    useEffect(() => {
        if (isErrorItem || isErrorKategori) {
            handleIsError();
        }
    }, [handleIsError, isErrorItem, isErrorKategori]);

    const isCurrentUkmDueExpired = React.useMemo(() => {
        if (!ukmData || !ukmIsDueExpired?.totalElements) {
            return false;
        }
        return (
            ukmIsDueExpired.content.findIndex(
                (list) => list.id === ukmData.id,
            ) > -1
        );
    }, [ukmData, ukmIsDueExpired?.content, ukmIsDueExpired?.totalElements]);

    const containerHeight = React.useMemo(() => {
        if (isPhoneScreen) {
            return isCurrentUkmDueExpired
                ? "calc(100vh - 146px)"
                : "calc(100vh - 56px)";
        }
        if (isLaptopScreen) {
            return isCurrentUkmDueExpired ? "calc(100vh - 48.75px)" : "100vh";
        }
        return "calc(100vh - 64px)";
    }, [isCurrentUkmDueExpired, isLaptopScreen, isPhoneScreen]);

    return (
        <>
            <Box
                display="grid"
                gridTemplateRows="auto 1fr"
                sx={{
                    height: containerHeight,
                }}
            >
                <Box alignItems="center" margin={2}>
                    <Stack
                        direction={{ xs: "column-reverse", lg: "row" }}
                        justifyContent="space-between"
                        spacing={2}
                    >
                        <Stack direction="row" spacing={1} width="100%">
                            <Box>
                                <TextField
                                    placeholder="Cari barang..."
                                    size="small"
                                    fullWidth
                                    value={search}
                                    onChange={handleChangeSearch}
                                    onKeyPress={(e) => {
                                        if (e.key !== "Enter") {
                                            return;
                                        }
                                        const element =
                                            e.target as HTMLInputElement;
                                        const value = element.value;
                                        setParamsItem((prev) => {
                                            if (
                                                prev.search === value &&
                                                prev.page === 1
                                            ) {
                                                return prev;
                                            }
                                            return {
                                                ...prev,
                                                search: value,
                                                page: 1,
                                            };
                                        });
                                        setUrlState({ search: value });
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleSearch}
                                                >
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                />
                            </Box>
                            <Box
                                sx={{
                                    width: { xs: "50%", sm: "50%" },
                                    justifyContent: "flex-end",
                                }}
                            >
                                <FormControl size="small" fullWidth>
                                    <InputLabel id="demo-simple-select-helper-label">
                                        Kategori
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        label="Kategori"
                                        value={kategori}
                                        onChange={(e) =>
                                            setKategori(String(e.target.value))
                                        }
                                    >
                                        <MenuItem value="">Semua</MenuItem>
                                        {datakategori &&
                                            datakategori?.content.map((k) => (
                                                <MenuItem
                                                    key={k.id}
                                                    value={k.id}
                                                >
                                                    {k.nama}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Stack>
                        <Box
                            display={
                                item
                                    ? ukmData
                                        ? ukmData.limitItem
                                            ? item.pages[0].results.totalItem >=
                                              ukmData.limitItem
                                                ? "none"
                                                : undefined
                                            : item.pages[0].results.totalItem >=
                                                500
                                              ? "none"
                                              : undefined
                                        : "none"
                                    : "none"
                            }
                        >
                            <Button
                                disabled={
                                    user && !user.akses.transaksi.includes(11)
                                }
                                variant="contained"
                                onClick={handleClickOpen}
                                startIcon={<AddIcon />}
                                size={isTabletScreen ? "small" : "medium"}
                                sx={{
                                    lineHeight: 2,
                                }}
                            >
                                Tambah
                            </Button>
                        </Box>
                    </Stack>
                    <Stack
                        direction="row"
                        spacing={2}
                        marginTop={3}
                        marginBottom={1}
                        alignItems="center"
                    >
                        <Button
                            size="small"
                            variant={isCardView ? "outlined" : "contained"}
                            onClick={listView}
                        >
                            <ViewListIcon />
                        </Button>
                        <Button
                            size="small"
                            variant={isCardView ? "contained" : "outlined"}
                            onClick={cardView}
                        >
                            <GridViewIcon />
                        </Button>
                    </Stack>
                </Box>
                {loadingItem === "loading" ||
                loadingUser === "loading" ||
                loadingKategori === "loading" ? (
                    <Box
                        position="relative"
                        height={
                            isLaptopScreen
                                ? "calc(100vh - 40px)"
                                : "calc(100vh - 56px)"
                        }
                    >
                        <Spinner />
                    </Box>
                ) : isCardView ? (
                    <Box className="hide-scroll" marginX={2}>
                        {item ? (
                            <React.Fragment>
                                {item.pages.map((page) =>
                                    page.results.totalElements > 0 ? (
                                        <React.Fragment
                                            key={page.results.nextId}
                                        >
                                            <Box
                                                display="grid"
                                                gridTemplateColumns="repeat(auto-fill, minmax(150px, 1fr))"
                                                gap={3}
                                            >
                                                {page.results.content.map(
                                                    (item) => (
                                                        <MenuBarang
                                                            key={item.id}
                                                            barang={item}
                                                        />
                                                    ),
                                                )}
                                            </Box>
                                        </React.Fragment>
                                    ) : (
                                        <Box
                                            display="flex"
                                            flex={1}
                                            flexDirection="column"
                                            alignItems="center"
                                            justifyContent="center"
                                            height="100%"
                                        >
                                            <BarangTidakDitemukan
                                                width="50%"
                                                style={{
                                                    height: "fit-content",
                                                }}
                                            />
                                            <Typography
                                                marginTop={5}
                                                variant="h6"
                                                fontWeight="bold"
                                            >
                                                Barang tidak ditemukan
                                            </Typography>
                                        </Box>
                                    ),
                                )}
                                {hasNextPage && (
                                    <Box width="100%" paddingY={2}>
                                        <LoadingButton
                                            variant="outlined"
                                            onClick={() => fetchNextPage()}
                                            loading={isFetchingNextPage}
                                            loadingPosition="center"
                                            size="large"
                                            fullWidth
                                        >
                                            {hasNextPage
                                                ? "Muat lebih banyak"
                                                : "Tidak ada lagi yang bisa dimuat"}
                                        </LoadingButton>
                                    </Box>
                                )}
                            </React.Fragment>
                        ) : (
                            <Box
                                display="flex"
                                flex={1}
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                height="100%"
                            >
                                <BarangTidakDitemukan
                                    width="50%"
                                    style={{ height: "fit-content" }}
                                />
                                <Typography
                                    marginTop={5}
                                    variant="h6"
                                    fontWeight="bold"
                                >
                                    Barang tidak ditemukan
                                </Typography>
                            </Box>
                        )}
                    </Box>
                ) : (
                    <Box className="hide-scroll" marginX={2}>
                        {item ? (
                            <React.Fragment>
                                {item.pages.map((page) =>
                                    page.results.totalElements > 0 ? (
                                        <React.Fragment
                                            key={page.results.nextId}
                                        >
                                            {page.results.content.map((item) =>
                                                isTabletScreen ? (
                                                    <CardBarangMini
                                                        key={item.id}
                                                        barang={item}
                                                        onOpenDetail={handleOpenDetailBarang}
                                                    />
                                                ) : (
                                                    <CardBarang
                                                        key={item.id}
                                                        barang={item}
                                                        onOpenDetail={handleOpenDetailBarang}
                                                    />
                                                ),
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <Box
                                            display="flex"
                                            flex={1}
                                            flexDirection="column"
                                            alignItems="center"
                                            justifyContent="center"
                                            height="100%"
                                        >
                                            <BarangTidakDitemukan
                                                width="50%"
                                                style={{
                                                    height: "fit-content",
                                                }}
                                            />
                                            <Typography
                                                marginTop={5}
                                                variant="h6"
                                                fontWeight="bold"
                                            >
                                                Barang tidak ditemukan
                                            </Typography>
                                        </Box>
                                    ),
                                )}
                                {hasNextPage && (
                                    <Box
                                        width="100%"
                                        paddingY={isTabletScreen ? 1 : 2}
                                    >
                                        <LoadingButton
                                            variant="outlined"
                                            onClick={() => fetchNextPage()}
                                            loading={isFetchingNextPage}
                                            loadingPosition="center"
                                            size={
                                                isTabletScreen
                                                    ? "small"
                                                    : "large"
                                            }
                                            fullWidth
                                        >
                                            {hasNextPage
                                                ? "Muat lebih banyak"
                                                : "Tidak ada lagi yang bisa dimuat"}
                                        </LoadingButton>
                                    </Box>
                                )}
                            </React.Fragment>
                        ) : (
                            <Box
                                display="flex"
                                flex={1}
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                height="100%"
                            >
                                <BarangTidakDitemukan
                                    width="50%"
                                    style={{ height: "fit-content" }}
                                />
                                <Typography
                                    marginTop={5}
                                    variant="h6"
                                    fontWeight="bold"
                                >
                                    Barang tidak ditemukan
                                </Typography>
                            </Box>
                        )}
                    </Box>
                )}
            </Box>
            {isOpenModalStok && (
                <ModalStok
                    open={isOpenModalStok}
                    onClose={closeModalStok}
                    dataStok={dataStok}
                    onOpenMutasi={onOpenMutasi}
                />
            )}
            {detailModalState.open && (
                <ModalDetailBarang
                    open={detailModalState.open}
                    onClose={handleCloseDetailBarang}
                    namaBarang={detailModalState.namaBarang}
                    deskripsi={detailModalState.deskripsi}
                    url={detailModalState.url}
                />
            )}
        </>
    );
};

export default React.memo(ListBarang);
